import { memo } from "react";
import { IProps } from "./table-menu-filter-list.types";
import { SpinnerUntil } from "@edgetier/components";
import { TableMenuItem } from "@edgetier/client-components";
import "./table-menu-filter-list.scss";

/**
 * Display a list of items that when clicked run a callback.
 * @param props.labelProperty        Name of the item's property that will show as a label.
 * @param props.isLoading            Whether the items are loading or not.
 * @param props.items                Array of options.
 * @param props.onClick              A callback that will run when an item is clicked.
 * @param props.value                The selected value from the menu.
 * @param props.valueProperty        Name of the item's property that will be put in the URL.
 * @returns                          List of clickable items.
 */
const TableMenuFilterList = <Item extends {}>({
    labelProperty,
    isLoading = false,
    items,
    onClick,
    value,
    valueProperty,
}: IProps<Item>) => {
    return (
        <SpinnerUntil<Item[]> data={items} isReady={!isLoading}>
            {(data) =>
                data.map((item) => (
                    <TableMenuItem
                        key={String(item[valueProperty])}
                        isActive={item[valueProperty] === value}
                        onClick={() => onClick(item[valueProperty])}
                    >
                        {item[labelProperty]}
                    </TableMenuItem>
                ))
            }
        </SpinnerUntil>
    );
};

export default memo(TableMenuFilterList) as typeof TableMenuFilterList;
